<section class="content">
    <section>
        <div class="row">
            <div class="box  box-primary">
                    <PageHeader class="pageHeaderButtonPosition" [title]="title"  #pageheader
                        [(searchText)]="searchText" [isSearchOpen]="ShowSearch"
                        (searchShowChange)="onSearchShowChange($event)" [showMainListing]="false" [showCheckInInventory]="true"></PageHeader>
                
                <div id="divSearch row" *ngIf="ShowSearch">


                    <div class="col-md-12 box ibox box-primary boxSearch">
                        <div class="box-header">
                            <h3 class="box-title">Search Records</h3>
                        </div>

                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">Category:</label>
                                            <div class="col-sm-6">
                                                <select class="form-control" (change)="fillManufacturers()"
                                                        name="categoryId" [(ngModel)]="page.Category">
                                                        <option value="{{item.text}}"
                                                            *ngFor="let item of CategoryList">{{item.text}}</option>
                                                    </select>
                                            </div>


                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                      <div class="col-sm-6">
                                        <div>
                                            <label class="col-sm-6 control-label">Vendor:</label>
                                            <div class="col-sm-6">
                                                <select class="form-control" [(ngModel)]="page.Vendor">
                                                    <option value="">Select</option>
                                                    <option value="{{item.contactId}}" *ngFor="let item of VendorList">
                                                        {{item.givenName}}
                                                    </option>
                                                </select>
                                          </div>
                                      </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">Manufacturer:</label>
                                            <div class="col-sm-6">                                              
                                                     <select class="form-control" [(ngModel)]="page.manufacturerId"
                                                        name="manufacturerId" (change)="fillAndSetModelList()">
                                                        <option value="">Select</option>
                                                        <option value="{{item.value}}"
                                                            *ngFor="let item of ManufacturerList">{{item.text}}</option>
                                                    </select>
                                            </div>


                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="col-sm-6 control-label">Model:</label>
                                                <div class="col-sm-6">
                                                     <select class="form-control" [(ngModel)]="page.modelId"
                                                        name="modelId">
                                                        <option value="">Select</option>
                                                        <option value="{{item.value}}" *ngFor="let item of ModelList">
                                                            {{item.text}}</option>
                                                    </select>
                                                </div>


                                            </div>
                                            <div class="clearfix"></div>
                                        </div>

                                </div>
                            </div>
                        </div>

                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                   <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">Product/Part ID:</label>
                                            <div class="col-sm-6">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    [(ngModel)]="page.ProductId"
                                                >
                                            </div>


                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label class="col-sm-6 control-label">Product/Part Name:</label>
                                            <div class="col-sm-6">
                                                <input type="text" class="form-control" [(ngModel)]="page.ProductName">
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <div>
                                            <label class="col-sm-6 control-label">Description:</label>
                                            <div class="col-sm-6">
                                                <input type="text" class="form-control" [(ngModel)]="page.ProductDesc">


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                      <div>
                                          <label class="col-sm-6 control-label">Present Equipment Status:</label>
                                          <div class="col-sm-6">
                                              <select class="form-control" [(ngModel)]="page.Status">
                                                  <option value="{{item.value}}" *ngFor="let item of StatusList">
                                                      {{item.text}}
                                                  </option>
                                              </select>


                                          </div>
                                      </div>
                                  </div>
                                </div>
                            </div>
                        </div>
 
                        <searchbutton (searchClick)="executeInventorySearch()" (cancelClick)="hideSearch()"></searchbutton>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="box-body" id="dvboxbody">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6 pull-right zIndex1000">
                                <div class="col text-right">
                                    <ngb-pagination pageSize="25" [boundaryLinks]="true"
                                        [collectionSize]="page.totalElements" [(page)]="page.pageNumber"
                                        (pageChange)="setPage()" [maxSize]="10" [directionLinks]="true">
                                    </ngb-pagination>
                                </div>
                            </div>
                            <div class="col-sm-3 pull-right noBorderSearchPadding zIndex1000">

                                    <select class="form-control noBorderSearch" [(ngModel)]="page.Division"
                                        (change)="DialysisUnitDropDownChanged()">
                                        <option value="{{item.value}}" *ngFor="let item of DivisionList">
                                            {{item.text}}
                                        </option>
                                    </select>

                            </div>
                            <div class="col-sm-3">
                                <div class="col text-left noofrecords">
                                    <span>
                                        <b>
                                            {{page.totalElements}}  {{page.totalElements > 1 ? 'Records' : 'Record'}} Found.
                                        </b>
                                    </span>
                                    <span *ngIf="blnDirtySearch">
                                        <a style="cursor:pointer" (click)="executeInventorySearchClear()">
                                            (
                                            <span>
                                                <i class="fa fa-trash-o"></i>
                                            </span>
                                            <b>Clear Search</b>
                                        </a>
                                        )
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive-custom">
                        <table id="OptionList" class="table table-bordered table-striped dataTable no-footer"
                            role="grid" style="overflow-x: auto; white-space: nowrap;">
                            <thead>
                                <tr>
                                    <th *ngFor="let tableHeader of tableHeaders"
                                        [ngClass]="setSortIndicator(tableHeader.Label)"
                                        [style.width.%]="tableHeader.Width" (click)="changeSorting(tableHeader.Label)">
                                        {{tableHeader.Label}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let InventoryDetail of rows;let index=index;" 
                                    (click)="_onRowClick(InventoryDetail.equipementid,InventoryDetail.equipmentdesc,InventoryDetail.serialnumber, InventoryDetail.equipmentcode,InventoryDetail.inservicedate,InventoryDetail.pmScheduleStatus,InventoryDetail.pmScheduleStatusType,InventoryDetail.quantity )"
                                    style="cursor: pointer;">
                                    <td matTooltip="{{InventoryDetail.equipmentdesc}}" matTooltipShowDelay="500">
                                        {{(page.pageSize*(page.currentPageNumber-1)) + (index + 1)}}
                                    </td>
                                    <td matTooltip="{{InventoryDetail.equipmentdesc}}" style="text-align: left;">
                                        {{InventoryDetail.equipmentcode}} {{InventoryDetail.divisionId}}
                                    </td>
                                    <td matTooltip="{{InventoryDetail.equipmentdesc}}" style="text-align: left;">
                                        <a (click)="onEquipmentClick(InventoryDetail); $event.stopPropagation()"
                                            style="text-decoration: underline; cursor: pointer;">{{ (InventoryDetail.equipmentname.length>50)? (InventoryDetail.equipmentname | slice:0:50)+'..':(InventoryDetail.equipmentname) }}</a>
                                    </td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">{{InventoryDetail.model}}</td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">{{InventoryDetail.vendorName}}</td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">{{InventoryDetail.presentstaus}}</td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">
                                         <a href="javascript:void(0)" title="Part Quantity History" *ngIf="!page.Division && InventoryDetail.quantity != 0"
                                            (click)="openQuantityPopup(InventoryDetail.quantity, InventoryDetail.equipementid); $event.stopPropagation()"
                                            style="text-decoration: underline; cursor: pointer;">
                                            {{InventoryDetail.quantity}}
                                        </a>
                                        <span *ngIf="page.Division || InventoryDetail.quantity == 0">{{InventoryDetail.quantity}}</span>
                                    </td>
                                    <td  matTooltip="{{InventoryDetail.equipmentdesc}}">
                                        {{(InventoryDetail.itemcost |
                                            currency:"CAD":"symbol-narrow")}}
                                    </td>
                                    <td><a><i class="fa fa-bars"></i></a>
                                      &nbsp;&nbsp;
                                      <a style="margin-left: 2px;" (click)="$event.stopPropagation(); openInventory(InventoryDetail);"><i class="fa fa-plus" style="cursor: pointer;"></i></a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-9 pull-right zIndex1000">
                                <div class="col text-right">
                                    <ngb-pagination pageSize="25" [boundaryLinks]="true"
                                        [collectionSize]="page.totalElements" [(page)]="page.pageNumber"
                                        (pageChange)="setPage()" [maxSize]="10" [directionLinks]="true">
                                    </ngb-pagination>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="col text-left noofrecords">
                                    <span>
                                        <b>
                                            {{page.totalElements}}  {{page.totalElements > 1 ? 'Records' : 'Record'}} Found.
                                        </b>
                                    </span>
                                    <span *ngIf="blnDirtySearch">
                                        <a style="cursor:pointer" (click)="executeInventorySearchClear()">
                                            (
                                            <span>
                                                <i class="fa fa-trash-o"></i>
                                            </span>
                                            <b>Clear Search</b>
                                        </a>
                                        )
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>
